import { PublicSiteInformation } from 'model';
import { useState } from 'react';
import { Swiper as SwiperCore } from 'swiper';
import { getPages } from '../components/GettingStartedPages';

interface UseGettingStartedPagesProps {
	siteSettings?: PublicSiteInformation | undefined;
	tabs?: boolean;
}

export const useGettingStartedPages = ({ siteSettings, tabs = false }: UseGettingStartedPagesProps) => {
	const [swiperInstance, setSwiperInstance] = useState<SwiperCore | null>(null);
	const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);

	const handleSlideChange = (swiper: SwiperCore) => {
		const index = swiper.activeIndex;
		setCurrentImageIndex(index);
	};

	const handleClick = (index: number) => {
		swiperInstance?.slideTo(index);
	};

	const Pages = getPages(siteSettings, handleClick, tabs);

	return {
		swiperInstance,
		setSwiperInstance,
		currentImageIndex,
		handleSlideChange,
		handleClick,
		Pages
	};
};
